import {
  Gauge, BarChart3, Activity, Users, ShieldCheck, CreditCard,
  CalendarDays, FileText, Search, MapPin, Settings2, GraduationCap,
} from "lucide-react";

export const NAV_GROUPS = [
  {
    label: "Operate",
    items: [
      { to: "/admin", end: true, icon: Gauge, label: "Overview" },
      { to: "/admin/analytics", icon: BarChart3, label: "Analytics" },
      { to: "/admin/sessions", icon: Activity, label: "Sessions" },
      { to: "/admin/customers", icon: Users, label: "Customers" },
      { to: "/admin/priests", icon: ShieldCheck, label: "Priests" },
      { to: "/admin/patashala", icon: GraduationCap, label: "Patashala Students" },
      { to: "/admin/payments", icon: CreditCard, label: "Payments" },
    ],
  },
  {
    label: "Publish",
    items: [
      { to: "/admin/puja-catalog", icon: CalendarDays, label: "Puja catalog" },
      { to: "/admin/content", icon: FileText, label: "Content" },
      { to: "/admin/search-growth", icon: Search, label: "Search growth" },
      { to: "/admin/location-pages", icon: MapPin, label: "Location pages" },
      { to: "/admin/configuration", icon: Settings2, label: "Configuration" },
    ],
  },
];
